import { render } from "./Presenting.vue?vue&type=template&id=3dd1ce2e&scoped=true"
import script from "./Presenting.vue?vue&type=script&lang=js"
export * from "./Presenting.vue?vue&type=script&lang=js"

import "./Presenting.vue?vue&type=style&index=0&id=3dd1ce2e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3dd1ce2e"

export default script